"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DomainInput = DomainInput;
exports.domainStates = void 0;

var _fieldAlert = require("../field-alert");

var _fieldError = require("../field-error");

var _fieldsStyledComponents = require("../fields-styled-components");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _reactForms = require("@seegno/react-forms");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["className", "disabled", "domain", "hasErrorRule", "hasIcon", "helpText", "id", "isFloating", "label", "name", "onChange", "status", "type"],
    _excluded2 = ["error", "meta", "value"];

var _switchProp, _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Export `domainStates`.
 */
var domainStates = {
  available: 'available',
  checking: 'checking',
  unavailable: 'unavailable',
  unknown: 'unknown'
};
/**
 * `Props` type.
 */

exports.domainStates = domainStates;

/**
 * `StyledFormControlWrapper` styled component.
 */
var StyledFormControlWrapper = (0, _styledComponents["default"])(_fieldsStyledComponents.FormControlWrapper).withConfig({
  displayName: "domain-input__StyledFormControlWrapper",
  componentId: "sc-k6gvee-0"
})(["column-gap:16px;", ""], (0, _styledTools.switchProp)('status', (_switchProp = {}, _defineProperty(_switchProp, domainStates.available, (0, _styledComponents.css)(["&,&:hover{", "}"], (0, _styledTools.ifProp)({
  disabled: false,
  hasError: false,
  hasValue: true
}, (0, _styledComponents.css)(["border-color:", ";"], (0, _styles.color)('success500'))))), _defineProperty(_switchProp, domainStates.checking, (0, _styledComponents.css)(["&,&:hover{", "}"], (0, _styledTools.ifProp)({
  disabled: false,
  hasValue: true
}, (0, _styledComponents.css)(["border-color:", ";"], (0, _styles.color)('warning500'))))), _defineProperty(_switchProp, domainStates.unavailable, (0, _styledComponents.css)(["&,&:hover{", "}"], (0, _styledTools.ifProp)({
  disabled: false,
  hasValue: true
}, (0, _styledComponents.css)(["border-color:", ";"], (0, _styles.color)('danger500'))))), _defineProperty(_switchProp, domainStates.unknown, (0, _styledComponents.css)(["&,&:hover{", "}"], (0, _styledTools.ifProp)({
  hasErrorRule: true
}, (0, _styledComponents.css)(["border-color:", ";"], (0, _styles.color)('warning500'))))), _switchProp)));
/**
 * `StyledFormControl` styled component.
 */

var StyledFormControl = (0, _styledComponents["default"])(_fieldsStyledComponents.FormControl).withConfig({
  displayName: "domain-input__StyledFormControl",
  componentId: "sc-k6gvee-1"
})(["flex:1;padding-right:0;", " ", ""], (0, _styledTools.ifProp)({
  hasErrorColor: true,
  hasFocus: false
}, (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('danger')), (0, _styledComponents.css)(["color:inherit;"])), _styles.media.min('md')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-right: 0;\n  "]))));
/**
 * `Domain` styled component.
 */

var Domain = _styledComponents["default"].div.withConfig({
  displayName: "domain-input__Domain",
  componentId: "sc-k6gvee-2"
})(["align-items:center;color:", ";display:flex;padding-right:12px;position:relative;transition:color ", ";", ""], (0, _styles.color)('gray500'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('gray400'))));
/**
 * Export `DomainInput` component.
 */


function DomainInput(props) {
  var className = props.className,
      disabled = props.disabled,
      domain = props.domain,
      hasErrorRule = props.hasErrorRule,
      hasIcon = props.hasIcon,
      helpText = props.helpText,
      id = props.id,
      isFloating = props.isFloating,
      label = props.label,
      name = props.name,
      _onChange = props.onChange,
      status = props.status,
      type = props.type,
      rest = _objectWithoutProperties(props, _excluded);

  var _useField = (0, _reactForms.useField)(name),
      error = _useField.error,
      meta = _useField.meta,
      _useField$value = _useField.value,
      value = _useField$value === void 0 ? '' : _useField$value,
      fieldProps = _objectWithoutProperties(_useField, _excluded2);

  var _ref = meta || {},
      active = _ref.active,
      touched = _ref.touched;

  var _useFormState = (0, _reactForms.useFormState)(),
      alreadySubmittted = _useFormState.alreadySubmittted,
      isSubmitting = _useFormState.isSubmitting;

  var hasValue = Boolean(value);
  var hasError = !!error && alreadySubmittted;
  var isDisabled = disabled || isSubmitting;
  return /*#__PURE__*/_react["default"].createElement(_fieldsStyledComponents.FormGroup, {
    className: className,
    disabled: isDisabled,
    hasAlert: hasError || !!helpText
  }, /*#__PURE__*/_react["default"].createElement(StyledFormControlWrapper, {
    disabled: isDisabled,
    hasError: hasError,
    hasErrorRule: hasErrorRule,
    hasFocus: active,
    hasValue: active || hasValue && !touched,
    status: status
  }, /*#__PURE__*/_react["default"].createElement(_fieldsStyledComponents.Label, {
    disabled: isDisabled,
    htmlFor: id !== null && id !== void 0 ? id : name,
    isFloating: isFloating !== null && isFloating !== void 0 ? isFloating : hasValue || active
  }, label), /*#__PURE__*/_react["default"].createElement(StyledFormControl, _extends({}, rest, fieldProps, {
    disabled: isDisabled,
    hasError: hasError,
    hasErrorColor: hasError && type !== 'warning',
    hasFocus: active,
    id: id !== null && id !== void 0 ? id : name,
    name: name,
    onChange: function onChange(event) {
      var value = event.target.value;
      fieldProps.onChange(value);

      if (_onChange) {
        _onChange(value);
      }
    },
    type: 'text',
    value: value
  })), /*#__PURE__*/_react["default"].createElement(Domain, {
    disabled: isDisabled
  }, domain)), helpText && /*#__PURE__*/_react["default"].createElement(_fieldAlert.FieldAlert, {
    isOpen: !hasError
  }, helpText), /*#__PURE__*/_react["default"].createElement(_fieldError.FieldError, {
    error: error,
    hasIcon: hasIcon,
    isOpen: hasError,
    name: name,
    type: type
  }));
}